import React, { useEffect, useContext, useState } from 'react'
import styled from 'styled-components'

import { H4 } from '@jarvis.oddle/core/components/Typo'
import { init } from '@jarvis.oddle/core/tools/lib'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'

import IconThreeDots from 'src/components/icons/IconThreeDots'

const SocialMediaSharingContainer = styled.div`
  margin: 30px 0;
`

const SocialMediaSharingIcons = styled.a`
  pointer-events: all;
  font-size: 0;
  box-sizing: border-box;
  display: inline-block;
  margin: 0 2px 5px;
  overflow: hidden;
  text-transform: none;
  transition: all .2s ease-in-out;
  border: 0;
  padding: 0;
  border-radius: 26px;
  width: 42px !important;
  height: 42px !important;
  & > span {
    height: auto !important;
    width: auto !important;
    padding: 5px;
  }
  &:hover {
    transform: translateY(-4px);
  }
`

const StyledSpanMoreIcon = styled.span`
  overflow: hidden;
  cursor: pointer;
  float: left;
  background-color: #bfc2c7;
`

const InlineSocialMediaSharing = ({ text, widgetId }: { text?: string, widgetId: string }): JSX.Element => {
  const { t } = useContext(TranslationContext)
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    async function initAddThis() {
      await init(`//s7.addthis.com/js/300/addthis_widget.js#pubid=${widgetId}`, `addthis-${widgetId}`)
      window.addthis && window.addthis.layers.refresh && window.addthis.layers.refresh()
      setIsReady(true)
    }
    initAddThis()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <SocialMediaSharingContainer>
      {isReady && <H4>{text || t('Share this product')}</H4>}
      <div className="addthis_toolbox addthis_32x32_style">
        <SocialMediaSharingIcons className="addthis_button_facebook"/>
        <SocialMediaSharingIcons className="addthis_button_twitter"/>
        <SocialMediaSharingIcons className="addthis_button_whatsapp"/>
        <SocialMediaSharingIcons className="addthis_button_messenger"/>
        {
          isReady &&
          <SocialMediaSharingIcons className="addthis_button_compact">
            <StyledSpanMoreIcon>
              <IconThreeDots width={32} height={32}/>
            </StyledSpanMoreIcon>
          </SocialMediaSharingIcons>
        }
      </div>
    </SocialMediaSharingContainer>
  )
}

export default InlineSocialMediaSharing
